import FavoriteResourceSortingContext from "contexts/favoriteResourceSortingContext"
import useAppSelector from "hooks/store/useAppSelector";
import { useMemo } from "react"
import FavoriteGamesCalculator from "services/favoriteResourceCalculator/games";
import FavoriteMarketsCalculator from "services/favoriteResourceCalculator/market";
import { selectIsDemoSession, selectSessionProjectId } from "store/slices/auth/selectors";

const FavoriteResourceSortingProvider = ({ children }) => {
	const isDemo = useAppSelector(selectIsDemoSession);
	const projectId = useAppSelector(selectSessionProjectId);

	const favoriteResourceSortingOrdersMap = useMemo(() => {
		const favoriteGameCalculator = new FavoriteGamesCalculator(projectId);
		const favoriteMarketsCalculator = new FavoriteMarketsCalculator(projectId);
		const disabled = Boolean(isDemo);
		favoriteGameCalculator.disabled = disabled;
		favoriteMarketsCalculator.disabled = disabled;
		const gamesSortingOrdersMap = favoriteGameCalculator.resource;
		const marketsSortingOrdersMap = favoriteMarketsCalculator.resource;

		const contextDefaultValue = {
			favoriteGames: gamesSortingOrdersMap,
			favoriteMarkets: marketsSortingOrdersMap
		}
		return contextDefaultValue;
	}, [projectId, isDemo]);

	return (
		<FavoriteResourceSortingContext.Provider value={favoriteResourceSortingOrdersMap}>
			{children}
		</FavoriteResourceSortingContext.Provider>
	);
}
export default FavoriteResourceSortingProvider